// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"87":"7d7d5abebc259c575229","501":"81b7ab25b4034893230b"}[chunkId] + ".js";
};